import React from "react";

import Chip from "@busbud/design-system-components/dist/Chip";
import Stack from "@busbud/design-system-components/dist/Stack";

import { AmenityIcon } from "@app/components/amenity-icon/amenity-icon";
import * as AmenitiesHelper from "@app/helpers/amenities";
import { useAppContext } from "@app/helpers/hooks";

import { useStyles } from "./amenities-chips.styles";

interface Props {
  amenities: string[];
}

export const AmenitiesChips: React.FC<Props> = React.memo(({ amenities }) => {
  const { translator } = useAppContext();
  const { classes } = useStyles();

  return (
    <Stack spacing={1} direction="row" flexWrap="wrap">
      {amenities.map(key => (
        <Chip
          key={key}
          classes={{
            root: classes.chip
          }}
          color="neutral"
          variant="subtle"
          startIcon={<AmenityIcon size="sm" amenity_key={key} />}
          label={AmenitiesHelper.getLabelText(translator, key)}
        />
      ))}
    </Stack>
  );
});
